import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withHousehold } from 'Context/HouseholdContext';
import Currency from 'Components/Format/Currency';
import { addSpacesAndCapitalizeAllWords } from 'Helpers/Formats';
import './TotalTable.css';
import AccountLinked from 'Components/UI/Accounts/AccountLinked';

class TotalTable extends Component {
  /* eslint-disable class-methods-use-this */

  getDisplayName(row) {
    if (!row.name) {
      return addSpacesAndCapitalizeAllWords(row.type);
    }
    return row.name.length > 25 ? `${row.name.substring(0, 25)}...` : row.name;
  }

  renderRows() {
    const { tableData } = this.props;
    return tableData.map(row => (
      <div
        className="table-row"
        key={`${row.id}-${row.accountAggregatorMetaId}-${row.externalAccountId}-${row.name}`}
      >
        <div className="row-name">
          {this.getDisplayName(row)}
          &nbsp;
          {row.isAccountAggregator && (
            <AccountLinked failed={row.isDisabled} lastSync={row.lastSync} />
          )}
        </div>

        <Currency className="row-value" amount={row.value} />
      </div>
    ));
  }

  renderTotalRow() {
    const { tableData, showTotalLabel } = this.props;
    const total = tableData.reduce((sum, asset) => sum + asset.value, 0);
    return (
      <div className="table-total">
        {showTotalLabel && <div className="total-row-name">Total</div>}
        <Currency className="table-total-value" amount={total} />
      </div>
    );
  }

  render() {
    const { showTotalRow } = this.props;
    return (
      <div className="total-table">
        {this.renderRows()}
        {showTotalRow && this.renderTotalRow()}
      </div>
    );
  }
}

TotalTable.propTypes = {
  tableData: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      isAccountAggregator: PropTypes.boolean,
      isDisabled: PropTypes.bool,
    }),
  ),
  showTotalLabel: PropTypes.bool,
  showTotalRow: PropTypes.bool,
};

TotalTable.defaultProps = {
  tableData: [
    {
      isAccountAggregator: false,
      isDisabled: false,
    },
  ],
  showTotalRow: true,
  showTotalLabel: true,
};

export default withHousehold(TotalTable);
